// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/posCheckout.css
// module id = 1332
// module chunks = 37